import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { useState } from "react";
import { List, SignOut, User as UserIcon } from "@phosphor-icons/react";
import SideMenu from "./SideMenu";
import BackButton from "./BackButton";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const navLinkCls = ({ isActive }) =>
    `text-sm font-medium transition-colors ${isActive ? "text-[#1E3F33]" : "text-[#5C6B64] hover:text-[#1E3F33]"}`;

  return (
    <header className="safe-top sticky top-0 z-50 backdrop-blur-xl bg-[#F9F6F0]/85 border-b border-[#E8E5DF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center min-w-0">
        <BackButton />
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2">
          <div className="w-9 h-9 rounded-xl bg-[#1E3F33] flex items-center justify-center">
            <span className="text-white font-display font-bold text-base">A</span>
          </div>
          <div className="leading-none">
            <div className="font-display font-bold text-lg text-[#1A1F1C]">ALLO DAKAR</div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#C85A17] mt-0.5">Transport · Sénégal</div>
          </div>
        </Link>
        </div>

        <nav className="hidden md:flex items-center gap-7">
          <NavLink to="/trajets" data-testid="nav-trajets" className={navLinkCls}>Départs</NavLink>
          <NavLink to="/colis" data-testid="nav-colis" className={navLinkCls}>Colis</NavLink>
          <NavLink to="/location" data-testid="nav-location" className={navLinkCls}>Louer une voiture</NavLink>
          {user && user.role === "admin" && (
            <NavLink to="/admin" data-testid="nav-admin" className={navLinkCls}>Admin</NavLink>
          )}
          {user && user.role === "driver" && (
            <NavLink to="/chauffeur" data-testid="nav-chauffeur" className={navLinkCls}>Espace chauffeur</NavLink>
          )}
          {user && user.role !== "admin" && (
            <NavLink to="/reservations" data-testid="nav-reservations" className={navLinkCls}>Réservations</NavLink>
          )}
          {user && user.role !== "admin" && (
            <NavLink to="/compte" data-testid="nav-compte" className={navLinkCls}>Mon compte</NavLink>
          )}
          <NavLink to="/aide" data-testid="nav-aide" className={navLinkCls}>Aide</NavLink>
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <>
              <div className="flex items-center gap-2 px-3 py-2 rounded-xl bg-white border border-[#E8E5DF]">
                <UserIcon size={16} weight="duotone" className="text-[#1E3F33]" />
                <span className="text-sm text-[#1A1F1C] font-medium" data-testid="user-name">{user.name}</span>
              </div>
              <button onClick={async () => { await logout(); navigate("/"); }} className="btn-outline" data-testid="logout-btn">
                <SignOut size={16} /> Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="btn-outline" data-testid="login-link">Connexion</Link>
              <Link to="/register" className="btn-primary" data-testid="register-link">S'inscrire</Link>
            </>
          )}
        </div>

        <button className="md:hidden p-2" onClick={() => setOpen(true)} data-testid="mobile-menu-toggle" aria-label="Menu">
          <List size={24} />
        </button>
      </div>

      <SideMenu open={open} onClose={() => setOpen(false)} />
    </header>
  );
}
